/*=========================================================================================
  File Name: moduleChatMutations.js
  Description: Chat Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";

export default {
	UPDATE_ABOUT_CHAT(state, obj) {
		obj.rootState.AppActiveUser.about = obj.value;
	},
	UPDATE_STATUS_CHAT(state, obj) {
		obj.rootState.AppActiveUser.status = obj.value;
	},
	ADD_TRACKING_CONTACT(state, resource) {
		const resourceIndex = state.contacts.findIndex((r) => r.id === resource.id);
		if (resourceIndex >= 0) Object.assign(state.contacts[resourceIndex], resource);
	},
	// API AFTER
	SEND_CHAT_MESSAGE(state, payload) {
		if (payload.chatData) {
			// If there's already chat. Push msg to existing chat
			state.chats[Object.keys(state.chats).find((key) => Number(key) === payload.id)].msg.push(payload.msg);
		} else {
			// Create New chat and add msg
			const chatId = payload.id;
			Vue.set(state.chats, [chatId], {isPinned: payload.isPinned, msg: [payload.msg]});
		}
	},
	UPDATE_CONTACTS(state, contacts) {
		state.contacts = contacts;
	},
	UPDATE_FCM_TOKEN_CONTACTS(state, users) {
		const fcmContacts = Object.entries(users)
			.map((user) => {
				const [key, data] = user;
				const hasFcmToken = Object.hasOwn(data, "fcm_token");
				if (!hasFcmToken) return {};
				return {contactId: +key, fcm_token: data.fcm_token, is_online: data.is_online};
			})
			.filter((user) => user.fcm_token);
		state.contactsFcm = fcmContacts;
	},
	UPDATE_CHAT_CONTACTS(state, firebaseData) {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));

		if (Object.hasOwn(firebaseData[userInfo.datarutas_id], "dm")) {
			const dmUsers = firebaseData[userInfo.datarutas_id].dm;
			const chatContacts = Object.entries(dmUsers).map((dm) => {
				const [chatKey, contactId] = dm;
				const foundContact = state.contacts.find((contact) => contact.id === contactId);
				if (!foundContact) return {};
				return {...foundContact, chatKey};
			});
			state.chatContacts = chatContacts;
		}
	},
	UPDATE_CHATS(state, firebaseData) {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		const chats = Object.entries(firebaseData)
			.sort((a, b) => {
				if (a[1]["messages"] && b[1]["messages"]) {
					if (
						Object.values(a[1]["messages"])[Object.values(a[1]["messages"]).length - 1].time_stamp <
						Object.values(b[1]["messages"])[Object.values(b[1]["messages"]).length - 1].time_stamp
					) {
						return 1;
					}
					if (
						Object.values(a[1]["messages"])[Object.values(a[1]["messages"]).length - 1].time_stamp >
						Object.values(b[1]["messages"])[Object.values(b[1]["messages"]).length - 1].time_stamp
					) {
						return -1;
					}
					return 0;
				}
			})
			// Filtramos los chats donde el usuario sea miembro
			.filter((chat) => {
				const [key, data] = chat;
				return Object.hasOwn(data, "members") && data.members.includes(userInfo.datarutas_id);
			})
			// Agregamos la propiedad name para los chat que no som grupales
			.map((chat) => {
				const [key, data] = chat;
				if (data.name) {
					return {...data, key};
				} else {
					const memberId = data.members.filter((member) => member !== userInfo.datarutas_id);
					const contactInfo = state.contacts.find((contact) => contact.id === memberId[0]);
					return {...data, name: contactInfo ? contactInfo.username : "not found", key};
				}
			});

		state.chats = chats;
	},
	SET_CHAT_SEARCH_QUERY(state, query) {
		state.chatSearchQuery = query;
	},
	MARK_SEEN_ALL_MESSAGES(state, payload) {
		payload.chatData.msg.forEach((msg) => {
			msg.isSeen = true;
		});
	},
	TOGGLE_IS_PINNED(state, payload) {
		state.chats[Object.keys(state.chats).find((key) => Number(key) === payload.id)].isPinned = payload.value;
	},
	ADD_CONTACT_IMAGE(state, payload) {
		const existImg = state.contactsImages.some((c) => c.id === payload.id);
		if (payload.id && !existImg) {
			state.contactsImages.push(payload);
		}
	},
	SET_TOTAL_UNSEEN(state) {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		try {
			const chatDm = state.chats.map((chat) => Object.values(chat.messages)).flat();
			const unseenDm = chatDm.filter(({sender, is_seen}) => +sender !== +userInfo.datarutas_id && !is_seen);
			state.unseenChats = unseenDm.length;
		} catch (error) {
			state.unseenChats = 0;
		}
	},
};
